module.exports = __webpack_public_path__ + "media/images/media/images/pic/teachers/wiktoria-piontek-120e0b7a63c84b9f79c24804d48e1894.webp";